export const randomId = (length = 8) => {
	const characters =
		'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	let result = '';

	for (let i = 0; i < length; i++) {
		const randomIndex = Math.floor(Math.random() * characters.length);
		result += characters.charAt(randomIndex);
	}

	return result;
};

export const formatDate = (date) => {
    const dateObj = new Date(date);
    return dateObj.toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric' });
};

export const formatPhoneNumber = (phoneNumberString) => {
   const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return null;
};

export const normalizeProviderSearchText = (value = '') =>
	value
		.toLowerCase()
		.replaceAll('.', '')
		.replaceAll(',', ' ')
		.trim()
		.replaceAll(/\s+/g, ' ');

const getProviderSearchTokens = (value) => {
	const normalizedValue = normalizeProviderSearchText(value);
	return normalizedValue ? normalizedValue.split(' ') : [];
};

export const matchesProviderName = (nameFormatted, query) => {
	const searchTokens = getProviderSearchTokens(query);
	if (!searchTokens.length) {
		return true;
	}

	const providerTokens = getProviderSearchTokens(nameFormatted || '');
	return searchTokens.every((searchToken) =>
		providerTokens.some((providerToken) => providerToken.includes(searchToken))
	);
};